import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './MetodePenyusutan.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

var _baseId = "mod-table-metode-penyusutan"

const MetodePenyusutanTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.metodePenyusutan.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Kode',
          searchable: true,
          key: 'kode',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kode)
        },{
          label: 'Metode',
          searchable: true,
          key: 'tipeMetodePenyusutanId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tipeMetodePenyusutan.nama)
        },{
          label: 'Masa Manfaat (Tahun)',
          searchable: true,
          key: 'masaManfaat',
          type: TableWrapper.dataTypes.STRING,
          render: item => (parseInt(item.masaManfaat)/12)
        },{
          label: 'Persentase (%)',
          searchable: true,
          key: 'persentase',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.persentase)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/metode-penyusutan/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/metode-penyusutan/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default MetodePenyusutanTable
